import React from 'react';
import { financialCalculators_Fr } from '../ConstantsFinancialCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices financieres en ligne gratuites en francais';
const DESCRIPTION = 'Accedez a des calculatrices financieres en francais pour la TVA, les marges, les remises, les salaires, le ROI, l inflation et le seuil de rentabilite. Des outils clairs pour independants, salaries, commercants et petites entreprises.';
const KEYWORDS = 'calculatrices financieres, calculatrice TVA, calcul marge, calcul ROI, calcul salaire, calculatrice remise, seuil de rentabilite, inflation';
const OG_URL = 'https://do-calculate.com/fr/financial-calculators/';

function FinancialCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Retrouvez sur cette page des calculatrices financieres utiles pour gerer un budget, fixer un prix de vente, verifier une marge, estimer un salaire, calculer une TVA ou mesurer la rentabilite d un projet. Les outils sont pensés pour des usages concrets: devis, commerce en ligne, activite freelance, suivi d entreprise ou comparaison de scenarios avant une decision.</p>
                    <p>Chaque calculatrice va droit au but avec une saisie simple, un resultat lisible et des explications faciles a comprendre. Si vous cherchez une calculatrice financiere en francais pour le quotidien, cette selection vous aide a gagner du temps sans noyer la page sous un jargon inutile.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {financialCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default FinancialCalculatorsList;
